import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AuthAction = lazy(() => import("@/pages/AuthAction"));

export const Route = createFileRoute("/auth/action")({
  component: AuthAction,
});
